var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view'),_c('el-backtop',[_c('i',{staticClass:"el-icon-arrow-up"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }